import axios from "axios";
import alert from "@/lang/AlertMessages.js";
// import label from "@/lang/StaticLabels.js";

const axiosClient = axios.create();
axiosClient.defaults.headers.common["Content-Type"] = "application/json";
axiosClient.defaults.headers.common["Authorization"] = "No Auth";

export default {
  getCarBrand({ dispatch, commit }) {
    axios
      .get("Client/car")
      .then((res) => {
        commit("setCarBrand", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCarModel({ dispatch, commit }, data) {
    axios
      .get("Client/car/" + data)
      .then((res) => {
        commit("setCarModel", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProvince({ dispatch, commit }) {
    axios
      .get("Client/Province")
      .then((res) => {
        commit("setProvince", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCity({ dispatch, commit }, data) {
    axios
      .get("Client/Province/" + data)
      .then((res) => {
        commit("setCity", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Services Actions -------------------------------------------------------------------------------
  getServices({ dispatch, commit }) {
    axios
      .get("Client/Service")
      .then((res) => {
        commit("setServices", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Banners Actions -------------------------------------------------------------------------------
  getCustomerBanners({ dispatch, commit }) {
    axios
      .get("client/Banner/Honor?PageSize=8")
      .then((res) => {
        commit("setCustomerBanners", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Blog Actions -------------------------------------------------------------------------------
  getBlogHome({ dispatch, commit }) {
    axios
      .get("client/Widget/1")
      .then((res) => {
        commit("setBlogHome", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Socials -------------------------------------------------------------------------------------------
  getSocials({ dispatch, commit }) {
    axios
      .get("Client/SocialNetwork")
      .then((res) => {
        commit("setSocials", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  //Products Actions............................................................................
  getProducts({ dispatch, commit }, data) {
    axios
      .get("client/Product?" + data)
      .then((res) => {
        commit("setProducts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getProductsListPage({ dispatch, commit }, data) {
    axios
      .get("client/Product?" + data)
      .then((res) => {
        commit("setProductsListPage", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCategory({ dispatch, commit }, data) {
    axios
      .get("client/Category?" + data)
      .then((res) => {
        commit("setCategory", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getRingFeature({ dispatch, commit }) {
    axios
      .get("client/Feature/104")
      .then((res) => {
        commit("setRingFeature", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getWideFeature({ dispatch, commit }) {
    axios
      .get("client/Feature/102")
      .then((res) => {
        commit("setWideFeature", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getRatioFeature({ dispatch, commit }) {
    axios
      .get("client/Feature/103")
      .then((res) => {
        commit("setRatioFeature", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProductDetail({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: "در حال بارگذاری ..." },
      { root: true }
    );
    axiosClient
      .get("client/Product/" + data)
      .then((res) => {
        commit("setProductDetail", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 800);
      });
  },

  getSimilarProducts({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: "در حال بارگذاری ..." },
      { root: true }
    );
    axiosClient
      .get("client/Product/GetSimilarProducts/" + data)
      .then((res) => {
        commit("setSimilarProducts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 800);
      });
  },

  getTabOneProducts({ dispatch, commit }) {
    axios
      .get("Client/Widget/2")
      .then((res) => {
        commit("setTabOneProducts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getTabTwoProducts({ dispatch, commit }) {
    axios
      .get("Client/Widget/3")
      .then((res) => {
        commit("setTabTwoProducts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getTabThreeProducts({ dispatch, commit }) {
    axios
      .get("Client/Widget/4")
      .then((res) => {
        commit("setTabThreeProducts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  //Page Actions ...........................................................
  getDynamicPageContent({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get("client/Page?name=" + data)
      .then((res) => {
        commit("setDynamicPageContent", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  //Tickets Actions ...........................................................

  getTicketCategory({ dispatch, commit }) {
    axios
      .get("client/TicketType")
      .then((res) => {
        commit("setTicketCategory", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  //Blog Action-----------------------------------------
  getBlogs({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axiosClient
      .get("client/Blog?" + data)
      .then((res) => {
        commit("setBlogs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 800);
      });
  },
  getBlogById({ dispatch, commit }, data) {
    axios
      .get("client/Blog/" + data)
      .then((res) => {
        commit("setBlog", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getRelatedBlogs({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get("client/Blog?categoryId=" + data)
      .then((res) => {
        commit("setRelatedBlogs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },

  //Service Action-----------------------------------------
  getService({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axiosClient
      .get("Client/Service/" + data)
      .then((res) => {
        commit("setService", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 800);
      });
  },

  //Faq Action-----------------------------------------
  getFaq({ dispatch, commit }) {
    commit("setLoading", 1, { root: true });
    axiosClient
      .get("client/Faq")
      .then((res) => {
        commit("setFaq", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 800);
      });
  },
  // Comments Actions -------------------------------------------------------------------------------
  getBlogComments({ dispatch, commit }, data) {
    axios
      .get(
        "client/Comment/GetPostCommentTreeJson?&entityId=" +
          data.entityId +
          "&pageNumber=" +
          data.pageNumber +
          "&pageSize=" +
          data.pageSize +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setComments", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  sendCommentBlogs({ dispatch, commit }, data) {
    axios
      .post("client/Blog", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.commentSent,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },

  getProductComments({ dispatch, commit }, data) {
    axios
      .get(
        "client/Comment/GetProductCommentTreeJson?&entityId=" +
          data.entityId +
          "&pageNumber=" +
          data.pageNumber +
          "&pageSize=" +
          data.pageSize +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setComments", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  sendCommentProducts({ dispatch, commit }, data) {
    axios
      .post("client/Product", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.commentSent,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },

  // NewsLetter Actions -------------------------------------------------------------------------------
  sendNewsLetter({ dispatch }, data) {
    axios
      .post("Client/Subscriber", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // slides Actions -------------------------------------------------------------------------------
  getSlides({ dispatch, commit }) {
    axios
      .get("client/Slider")
      .then((res) => {
        commit("setSlides", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  //Team Actions.....................................
  getTeam({ dispatch, commit }, data) {
    axios
      .get("Client/Team", data)
      .then((res) => {
        commit("setTeam", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // Poster Actions .....................................
  getPoster1({ dispatch, commit }) {
    axios
      .get("Client/Poster/GetByPosition/1")
      .then((res) => {
        commit("setPoster1", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getPoster2({ dispatch, commit }) {
    axios
      .get("Client/Poster/GetByPosition/2")
      .then((res) => {
        commit("setPoster2", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getPosterProducts({ dispatch, commit }) {
    axios
      .get("Client/Poster/GetByPosition/3")
      .then((res) => {
        commit("setPosterProducts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getPosterBlogs({ dispatch, commit }) {
    axios
      .get("Client/Poster/GetByPosition/4")
      .then((res) => {
        commit("setPosterBlogs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // Rules  .....................................
  getRules({ dispatch, commit }) {
    axios
      .get("client/Page?name=Rules")
      .then((res) => {
        commit("setRules", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
   // AboutUs  .....................................
   getAboutUs({ dispatch, commit }) {
    axios
      .get("client/Page?name=AboutUs")
      .then((res) => {
        commit("setAboutUs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
   // ContactUs  .....................................
   getContactUs({ dispatch, commit }) {
    axios
      .get("client/Page?name=ContactUs")
      .then((res) => {
        commit("setContactUs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // ContactMessages Actions -----------------------------
  sendMessage({ dispatch, commit }, data) {
    axios
      .post("Client/ContactUs", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
   // FAQ page .....................................
   getFAQpage({ dispatch, commit }) {
    axios
      .get("client/Page?name=FAQ")
      .then((res) => {
        commit("setFAQpage", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

   getBrands({ dispatch, commit }) {
    axios
      .get("client/Brand")
      .then((res) => {
        commit("setBrands", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
};
